import {Grid, Box, styled} from '@mui/material';
import {Color} from '../../../common/theme';

const WhiteBackgroundBox = styled(Box)({
    paddingTop: 64,
    paddingBottom: 64,
    paddingLeft: 32,
    paddingRight: 32,
    margin: 0,
    backgroundColor: Color.WHITE,
});

type KeyFeatureType = 'II' | 'MPS' | 'SEO' | 'SUPPORT';
const KeyFeatureItem = (props: {title: string; tagline: string; type: KeyFeatureType}) => {
    const {title, tagline, type} = props;

    const resolveImage = (imageType: KeyFeatureType): string => {
        switch (imageType) {
            case 'II':
                return '/1.png';
            case 'MPS':
                return '/2.png';
            case 'SEO':
                return '/3.png';
            case 'SUPPORT':
                return '/4.png';
        }
    };

    return (
        <Grid item xs={12} sm={6} md={3}>
            <div
                style={{
                    marginLeft: 16,
                    marginRight: 16,
                    marginBottom: 32,
                }}>
                <center>
                    <img height={64} width={64} src={resolveImage(type)} />
                </center>
                <br />
                <span
                    style={{
                        fontSize: 15,
                        fontWeight: 700,
                        fontFamily: 'Poppins',
                        color: Color.SEA_GREEN,
                    }}>
                    <center>{title}</center>
                </span>
                <span
                    style={{
                        fontSize: 12,
                        fontWeight: 200,
                        fontFamily: 'Poppins',
                        color: Color.BLACK,
                    }}>
                    <center>{tagline}</center>
                </span>
            </div>
        </Grid>
    );
};

export const KeyFeaturesSection = () => {
    return (
        <WhiteBackgroundBox>
            <Grid container>
                <Grid item md={12}>
                    <span
                        style={{
                            fontSize: 32,
                            color: Color.SEA_GREEN,
                            fontWeight: 700,
                            fontFamily: 'Poppins',
                        }}>
                        <center>Key Features</center>
                    </span>
                </Grid>
            </Grid>
            <br />
            <br />
            <Grid container>
                <KeyFeatureItem
                    title={'Intuitive Interface'}
                    tagline={
                        'No technical skills required, as easy as filling a form. Update your entire website in a few clicks'
                    }
                    type='II'
                />
                <KeyFeatureItem
                    title={'Multi Platform Support'}
                    tagline={
                        "Ensure your store looks great on all devices. We support all kinds of devices, from phones to pcs, we've got your covered"
                    }
                    type='MPS'
                />
                <KeyFeatureItem
                    title={'SEO Optimization'}
                    tagline={'Improve your search engine ranking and boost your online business presence'}
                    type='SEO'
                />
                <KeyFeatureItem
                    title={'24/7 Support'}
                    tagline={
                        'Get help whenever and wherever you need it. Our support team is always available to help you'
                    }
                    type='SUPPORT'
                />
            </Grid>
        </WhiteBackgroundBox>
    );
};
